// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL Reports API (nestjs)
 * API for reports in WL
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface SpellingByStudentIssueWordDateResponseDto
 */
export interface SpellingByStudentIssueWordDateResponseDto {
  /**
   * The correctly spelt word
   * @type {string}
   * @memberof SpellingByStudentIssueWordDateResponseDto
   */
  correctWord: string
  /**
   * The incorrectly spelt word(s)
   * @type {string}
   * @memberof SpellingByStudentIssueWordDateResponseDto
   */
  incorrectWords: string
  /**
   * The total number of correct spelling
   * @type {number}
   * @memberof SpellingByStudentIssueWordDateResponseDto
   */
  totalCorrect?: number | null
  /**
   * The total number of incorrect spelling
   * @type {number}
   * @memberof SpellingByStudentIssueWordDateResponseDto
   */
  totalIncorrect?: number | null
  /**
   * The error rate percentage
   * @type {number}
   * @memberof SpellingByStudentIssueWordDateResponseDto
   */
  errorRate?: number | null
}

/**
 * Check if a given object implements the SpellingByStudentIssueWordDateResponseDto interface.
 */
export function instanceOfSpellingByStudentIssueWordDateResponseDto(
  value: object,
): boolean {
  let isInstance = true
  isInstance = isInstance && 'correctWord' in value
  isInstance = isInstance && 'incorrectWords' in value

  return isInstance
}

export function SpellingByStudentIssueWordDateResponseDtoFromJSON(
  json: any,
): SpellingByStudentIssueWordDateResponseDto {
  return SpellingByStudentIssueWordDateResponseDtoFromJSONTyped(json, false)
}

export function SpellingByStudentIssueWordDateResponseDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SpellingByStudentIssueWordDateResponseDto {
  if (json === undefined || json === null) {
    return json
  }
  return {
    correctWord: json['correctWord'],
    incorrectWords: json['incorrectWords'],
    totalCorrect: !exists(json, 'totalCorrect')
      ? undefined
      : json['totalCorrect'],
    totalIncorrect: !exists(json, 'totalIncorrect')
      ? undefined
      : json['totalIncorrect'],
    errorRate: !exists(json, 'errorRate') ? undefined : json['errorRate'],
  }
}

export function SpellingByStudentIssueWordDateResponseDtoToJSON(
  value?: SpellingByStudentIssueWordDateResponseDto | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    correctWord: value.correctWord,
    incorrectWords: value.incorrectWords,
    totalCorrect: value.totalCorrect,
    totalIncorrect: value.totalIncorrect,
    errorRate: value.errorRate,
  }
}
